import { useState, useEffect, useRef } from 'react';
import { ChevronLeft, ChevronRight, Star } from 'lucide-react';
import axios from 'axios';

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [expanded, setExpanded] = useState({});
  const intervalRef = useRef(null);

  useEffect(() => {
    axios.get("https://backend.ysskytravel.com/api/reviews")
      .then((res) => setTestimonials(res.data))
      .catch((err) => console.error("Failed to load reviews:", err));
  }, []);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    if (!isPaused && testimonials.length > 0) {
      intervalRef.current = setInterval(nextSlide, 4000);
      return () => clearInterval(intervalRef.current);
    }
  }, [isPaused, testimonials]);

  // Return 1 testimonial on mobile, 3 on desktop
  const getVisibleTestimonials = () => {
    const isMobile = window.innerWidth < 768;
    const visibleCount = isMobile ? 1 : 3;

    if (testimonials.length < visibleCount) return testimonials;

    const list = [...testimonials, ...testimonials];
    return list.slice(currentIndex, currentIndex + visibleCount);
  };

  const toggleReadMore = (id) => {
    setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <div className="py-2">
      {testimonials.length > 0 && (
        <div className="max-w-7xl mx-auto px-4">
          
          <h1 className="text-center text-3xl md:text-5xl font-bold mb-2">
            Clients Testimonial
          </h1>

          <div
            className="relative mb-12"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}
          >
            <div className="overflow-hidden">
              
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {getVisibleTestimonials().map((t, i) => (
                  <div
                    key={i}
                    className="rounded-lg shadow-lg p-6 hover:shadow-xl transition-shadow flex flex-col justify-between min-h-[200px]"
                  >
                    <div>
                      <div className="flex items-center mb-4">
                        <img
                          src={t.avatar}
                          className="w-12 h-12 rounded-full mr-4"
                        />
                        <div>
                          <h3 className="font-semibold">{t.name}</h3>
                          <p className="text-sm text-gray-500">{t.time}</p>
                        </div>
                      </div>

                      <div className="flex">
                        {[...Array(t.rating)].map((_, i) => (
                          <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                        ))}
                      </div>

                      <p className="leading-relaxed">
                        {t.text.length > 200
                          ? expanded[t.review_id]
                            ? t.text
                            : t.text.substring(0, 200) + '...'
                          : t.text
                        }

                        {t.text.length > 200 && (
                          <button
                            onClick={() => toggleReadMore(t.review_id)}
                            className="ml-1 text-blue-600 underline text-sm"
                          >
                            {expanded[t.review_id] ? 'Read less' : 'Read more'}
                          </button>
                        )}
                      </p>
                    </div>

                    <div className="text-sm text-gray-500 mt-4">
                      <a
                        href="https://search.google.com/local/writereview?placeid=ChIJH2UVRpGBSxYRXTQ2Matm-Nk"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="underline text-blue-600"
                      >
                        Leave a Google Review
                      </a>
                      <p className="mt-2 text-gray-400 text-xs">Reviews powered by Google Maps</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* ---------- FIXED — BUTTONS BELOW ---------- */}
            <div className="flex justify-between px-8 gap-6 ">
              <button
                onClick={prevSlide}
                className="bg-white shadow p-3 rounded-full"
              >
                <ChevronLeft />
              </button>

              <button
                onClick={nextSlide}
                className="bg-white shadow p-3 rounded-full"
              >
                <ChevronRight />
              </button>
            </div>
            {/* ------------------------------------------- */}

          </div>
        </div>
      )}
    </div>
  );
};

export default Testimonials;
